export default "__VITE_ASSET__CIsLvVlN__"